// extracted by mini-css-extract-plugin
export default {"companyInfo":"style_companyInfo__yavS9"};